import { Component, OnInit } from '@angular/core';
import { CustomerOnboardFlowService } from '../customer-onboard-flow/customer-onboard-flow.service';
import { GlobalService } from 'app/global/global.service';
import { take } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { OnboardingFacade } from '../customer-onboard-flow/store/onboarding/onboarding.facade';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-team-invitation',
  templateUrl: './team-invitation.component.html',
  styleUrls: ['./team-invitation.component.scss'],
})
export class TeamInvitationComponent implements OnInit {

  public emailSet: string = '';
  public team_invite_token: string = '';
  public emailList: string[] = [];
  public emailSetInvalid: boolean = false;
  public error: string = '';
  public name: string = '';
  public loading: boolean = false; // Local loading state for this component

  constructor(
    private customerOnboardFlowService: CustomerOnboardFlowService,
    private _globalService$: GlobalService,
    private route: ActivatedRoute,
    private onboardingFacade: OnboardingFacade,
  ) { }

  ngOnInit(): void {
    this.team_invite_token = this.route.snapshot.paramMap.get('token') || ''
    this.customerOnboardFlowService.checkTeamInviteToken(this.team_invite_token)
      .pipe(take(1))
      .subscribe({
        next: (response: { first_name: string }) => {
          this.name = response.first_name;
        }
      });

  }


  onEmailSetKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      if (this.emailSet && this.emailSet.trim() !== '') {
        if (this.isValidEmail(this.emailSet)) {
          if (this.emailList.includes(this.emailSet)) {
            this.emailSet = '';
          } else {
            this.emailList.push(this.emailSet);
            this.emailSet = '';
          }
          this.emailSetInvalid = false;
        } else {
          this.emailSetInvalid = true;
        }
      }
    }
  }

  // Helper method to validate email format
  isValidEmail(email: string): boolean {
    const validatorResult = Validators.email(new FormControl(email));
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return validatorResult === null && emailRegex.test(email);
  }

  /**
   * Remove Email
   * @param index
   */
  removeEmail(index: number) {
    this.emailList.splice(index, 1);
    this.error = '';
  }

  skipTeamInvitation() {
    this.loading = true;
    this.customerOnboardFlowService.skipTeamInvitation()
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.loading = false;
          this.onboardingFacade.teamInvitationCompleted();
        },
        error: (error) => {
          this.error = error;
          this._globalService$.toastrError(error);
          this.loading = false;
        },
        complete: () => {
          this.loading = false;
        }
      });
  }

  submitTeamInvitation() {
    if (this.emailList.length !== 0) {
      this.loading = true;
      this.customerOnboardFlowService.sendTeamInvitation(this.emailList, this.team_invite_token)
        .pipe(take(1))
        .subscribe({
          next: () => {
            this.loading = false;
            this.onboardingFacade.teamInvitationCompleted();
          },
          error: (error) => {
            this._globalService$.toastrError(error);
            this.loading = false;
          },
          complete: () => {

            this.loading = false;
          }
        });
    }
  }
}
